module.exports = __webpack_public_path__ + "img/blackCircle.dbf1af2c.svg";